import React from "react";
import { ClockIcon, LockIcon, SparklesIcon } from "lucide-react";
import { images } from "../data/images";
import { PrimaryButton } from "./PrimaryButton";
interface StartScreenProps {
  onStart: () => void;
}
export function StartScreen({
  onStart
}: StartScreenProps) {
  return <section className="mx-auto grid max-w-5xl items-center gap-8 px-4 py-8 sm:px-6 md:grid-cols-[1.05fr_1fr] md:gap-12 md:py-16" data-id="element-377" data-mp="1ee7hhjqetw4n">
      <div className="order-2 md:order-1" data-id="element-378" data-mp="19g5uwotrzeof">
        <h1 className="font-serif text-[2.1rem] font-semibold leading-[1.1] text-cocoa sm:text-5xl" data-id="element-379" data-mp="19d067ap26et8">
          ¿Tu vientre se hincha aunque cenes <span className="italic text-rose-600" data-id="element-380" data-mp="10dwn46pw5zeq">“sano”</span>?
        </h1>
        <p className="mt-5 text-lg leading-relaxed text-cocoa sm:text-xl" data-id="element-381" data-mp="vfbky1r2x5nn">
          Respondé este test de 2 minutos y descubrí qué tipo de cena podría estar haciendo que tu cuerpo trabaje de
          más mientras dormís.
        </p>
        <div className="mt-6 space-y-3 border-l-2 border-blush-200 pl-4 text-base leading-relaxed text-cocoa-soft" data-id="element-382" data-mp="2pt33jqrdyzv8">
          <p data-id="element-383" data-mp="24vkkyrktmz9g">
            Muchas mujeres después de los 35 cenan ensalada, yogur, pan integral o “algo liviano”… y aun así amanecen
            con el abdomen tenso, la cara hinchada o cero energía.
          </p>
          <p data-id="element-384" data-mp="1vx8nq6pg9381">
            <strong className="font-semibold text-cocoa" data-id="element-385" data-mp="1vxqrdoefyjpz">El problema puede no ser cuánto comés.</strong> Puede ser cómo
            tu cuerpo está intentando digerir esa cena de noche.
          </p>
        </div>
        <div className="mt-8 max-w-md" data-id="element-386" data-mp="2ompbgr24jvxx">
          <PrimaryButton onClick={onStart} data-id="element-387" data-mp="2sm6ivq14335q">Empezar test gratuito</PrimaryButton>
          <ul className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-cocoa-soft" data-id="element-388" data-mp="2eurz3gzdqxxm">
            <li className="inline-flex items-center gap-1.5" data-id="element-389" data-mp="2jt35tiudosbm">
              <ClockIcon className="h-4 w-4 text-olive-600" aria-hidden="true" data-id="element-390" data-mp="2jri9bnoi6zb4" /> 2 minutos
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-391" data-mp="37hcnc8kk6twy">
              <SparklesIcon className="h-4 w-4 text-olive-600" aria-hidden="true" data-id="element-392" data-mp="3capaee9lasnl" /> Resultado personalizado
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-393" data-mp="3m3tij6wr7a3r">
              <LockIcon className="h-4 w-4 text-olive-600" aria-hidden="true" data-id="element-394" data-mp="3h7uph60hd3x0" /> Anónimo
            </li>
          </ul>
        </div>
      </div>
      <div className="order-1 md:order-2" data-id="element-395" data-mp="3c9t2wb3uimgs">
        <div className="relative overflow-hidden rounded-3xl bg-blush-100" data-id="element-396" data-mp="379euut28vcir">
          
          <p className="absolute bottom-4 left-4 right-4 rounded-2xl bg-cream/95 px-4 py-3 font-serif text-base italic leading-snug text-cocoa" data-id="element-397" data-mp="337jx1yjivh9q">
            “Ceno liviano y me levanto igual de hinchada.”
          </p>
        </div>
      </div>
    </section>;
}